import React, { useState } from "react";

import Carousel from "components/common/Carousel";
import ModalResponsive from "components/common/ModalResponsive";

import useWindowSize from "hooks/useWindowSize";

import {
  cardsList,
  EModals,
} from "./constants/SectionBoardsAndCommittees.constants";

import * as S from "./SectionBoardsAndCommittees.style";

const SectionBoardsAndCommittees = () => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [currentCard, setCurrentCard] = useState(cardsList[0]);
  const [currentModal, setCurrentModal] = useState(
    EModals.CNP_HOLDING_BRASIL_ASSEMBLEIA_GERAL
  );

  const handleMouseOver = (cardItem) => {
    if (!cardItem) {
      return;
    }

    setCurrentCard(cardItem);
  };

  function handleToggleModal(modal) {
    if (!modal) {
      return;
    }

    setCurrentModal(modal);
    setIsOpenModal((state) => !state);
  }

  return (
    <>
      <S.SectionBoardsAndCommitteesContainer className="container">
        <S.SectionBoardsAndCommitteesHeader>
          <S.SectionBoardsAndCommitteesTitle>
            Conselhos e Comitês
          </S.SectionBoardsAndCommitteesTitle>

          <S.SectionBoardsAndCommitteesDescription>
            Os órgãos e comitês que integram a nossa estrutura fortalecem a
            gestão e apoiam o crescimento sustentável do negócio. Confira quais
            são, como eles atuam e por quem são formados!
          </S.SectionBoardsAndCommitteesDescription>
        </S.SectionBoardsAndCommitteesHeader>

        {!isMobile ? (
          <>
            <S.SectionBoardsAndCommitteesContent>
              <S.SectionBoardsAndCommitteesControls>
                {cardsList.map((cardItem) => {
                  const isActiveCardItem = cardItem?.id === currentCard?.id;

                  return (
                    <S.SectionBoardsAndCommitteesControlItem
                      key={`${cardItem?.id}-control`}
                      $isActive={isActiveCardItem}
                      onMouseOver={() => handleMouseOver(cardItem)}
                    >
                      <S.SectionBoardsAndCommitteesControlItemTitle>
                        {cardItem?.title}
                      </S.SectionBoardsAndCommitteesControlItemTitle>

                      <S.SectionBoardsAndCommitteesControlItemSubtitle>
                        {cardItem?.subTitle}
                      </S.SectionBoardsAndCommitteesControlItemSubtitle>
                    </S.SectionBoardsAndCommitteesControlItem>
                  );
                })}
              </S.SectionBoardsAndCommitteesControls>

              <S.SectionBoardsAndCommitteesControlsImage>
                <img
                  src={currentCard?.img}
                  alt="fluxograma"
                  useMap={`#mapImage${currentCard?.id}`}
                />

                <map name={`#mapImage${currentCard?.id}`}>
                  {currentCard.imgMap.map((areaItem, index) => (
                    <area
                      key={`${currentCard.id}+${areaItem.coords}+${index}`}
                      shape="rect"
                      coords={areaItem.coordsDesktop}
                      alt=""
                      style={{ cursor: "pointer" }}
                      onClick={() => handleToggleModal(areaItem.modal)}
                    />
                  ))}
                </map>

                <S.SectionBoardsAndCommitteesDescription>
                  Para saber mais sobre cada órgão e seus integrantes,{" "}
                  <strong>clique nos nomes!</strong>
                </S.SectionBoardsAndCommitteesDescription>
              </S.SectionBoardsAndCommitteesControlsImage>
            </S.SectionBoardsAndCommitteesContent>
          </>
        ) : (
          <>
            <Carousel
              children={cardsList.map((cardItem) => (
                <S.SectionBoardsAndCommitteesCard
                  key={cardItem?.id + "carousel"}
                >
                  <S.SectionBoardsAndCommitteesCardHeader>
                    <S.SectionBoardsAndCommitteesCardTitle>
                      {cardItem?.title}
                    </S.SectionBoardsAndCommitteesCardTitle>

                    <S.SectionBoardsAndCommitteesCardSubtitle>
                      {cardItem?.subTitle}
                    </S.SectionBoardsAndCommitteesCardSubtitle>
                  </S.SectionBoardsAndCommitteesCardHeader>

                  <S.SectionBoardsAndCommitteesCardImage>
                    <img
                      src={cardItem?.imgMobile}
                      alt="fluxograma"
                      useMap={`#mapImage-mobile-${cardItem?.id}`}
                    />

                    <map name={`mapImage-mobile-${cardItem?.id}`}>
                      {cardItem?.imgMap.map((areaItem, index) => (
                        <area
                          key={`${cardItem?.id}+${areaItem.coords}+${index}+mobile`}
                          shape="rect"
                          coords={areaItem?.coordsMobile}
                          alt=""
                          style={{ cursor: "pointer" }}
                          onClick={() => handleToggleModal(areaItem.modal)}
                        />
                      ))}
                    </map>
                  </S.SectionBoardsAndCommitteesCardImage>
                </S.SectionBoardsAndCommitteesCard>
              ))}
            ></Carousel>

            <S.SectionBoardsAndCommitteesDescription>
              Para saber mais sobre cada órgão e seus integrantes,{" "}
              <strong>clique nos nomes!</strong>
            </S.SectionBoardsAndCommitteesDescription>
          </>
        )}
      </S.SectionBoardsAndCommitteesContainer>

      <ModalResponsive
        show={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        title={currentModal.title}
        subTitle={currentModal.subTitle}
        body={currentModal.body}
      />
    </>
  );
};

export default SectionBoardsAndCommittees;
